import { PrescriptionPadStep } from '@/components/PatientPageV2/components/PrescriptionPad/PrescriptionPad.types';
import type { PrescriptionHistoryState, PrescriptionPadState } from './types';

const initialPrescriptionPadReviewActions = [
  {
    id: 1,
    label:
      'I confirm that I have accessed all relevant real-time prescribing services in any state that may be relevant to this patient.',
    checked: false
  },
  {
    id: 2,
    label: 'I have documented thorough clinical notes for this consultation.',
    checked: false
  }
];

export const initialPrescriptionHistoryState: PrescriptionHistoryState = {
  itemsToAction: [],
  itemsToReissue: [],
  itemsToCancel: [],
  previousItems: []
};

export const initialPrescriptionPadState: PrescriptionPadState = {
  medicationPadItems: [],
  devicePadItems: [],
  step: PrescriptionPadStep.Create,
  actions: initialPrescriptionPadReviewActions,
  dispenseNote: '',
  showCancellation: false
};

export const initialStatePrescriptionAssistantSlice = {
  prescriptionHistory: initialPrescriptionHistoryState,
  prescriptionPad: initialPrescriptionPadState
};

// Create a mutable object to hold only the necessary reissue status properties
export const reissueStatusStore: {
  current: {
    productId?: number;
    isOutOfStock?: boolean;
    isDiscontinued?: boolean;
    isActive?: boolean;
    isUnavailable?: boolean;
  } | null;
} = { current: null };
